export const darkColor = {
    black: '#000',
    black1: '#0c0c0d',
    white: '#fff',
    whiteLight: '#aaa',
    whiteEEE: '#999',
    whitePointOne: 'rgba(255,255,255,0.1)',
    white1: '#f4f4f4f2',
    whiteToSecondary: '#fff',
    absoluteAAA: '#aaa',
    primaryLight: '#718EFF',
    primary: '#2616FF',
    primaryDark: '#093234',
    secondaryLight: '#838798',
    secondary: '#272931',
    secondaryDark: '#121317',
    accent: '#FF85FC',
    link: '#d1d155',
    buttonGradient: '#7D73FF',
    search: '#7B8198',
    searchFocus: '#C1C3CB',
    blurEffect: `rgba(18,19,22,.8)`,
    lightBlurEffect: `rgba(18,19,22,.01)`,
    gray: 'rgba(0,0,0,0.6)',
    gray1: 'rgba(0,0,0,0.2)',
    gray2: 'rgba(0,0,0,0.87)',
    gray3: 'rgba(0,0,0,0.05)',
    lightgray: 'rgba(0,0,0,0.03)',
    lightgray1: 'rgba(0,0,0,0.5)',
    lightgray2: 'rgba(0,0,0,0.05)',
    lightgray3: '#F6F7F8',
    lightgray4: 'rgba(0,0,0,0.1)',
    lightBlue1: 'rgba(20,200,230,0.05)',
    lightBlue2: '#F4FDFD',
    blueHeading: '#0a0676',
    gradient: 'linear-gradient(to bottom, #fff, #D6ECFA 30%, #CCFAFF 50%, #D6ECFA 70%, #fff)',
    mainGradient: 'linear-gradient(to right, #AABBFF, #A8A2FF 90%)',
    slantedGradient: 'linear-gradient(45deg, #fff, #D6ECFA 30%, #CCFAFF 50%, #D6ECFA 70%, #fff)',
    boxShadow: "0px 3px 11px 0px #e8eafc, 0 3px 3px -2px #b2b2b21a, 0 1px 8px 0 #9a9a9a1a",
    boxShadowBlack: "0px 3px 11px 0px #999, 0 3px 3px -2px #b2b2b21a, 0 1px 8px 0 #999",
    boxShadowZero: "0px 0px 0px 0px #999, 0 0px 0px 0px #b2b2b21a, 0 0px 1px 0 #999",
    boxShadowFooter: '0 -19px 20px 3px rgba(0, 0, 0, 0.5)',
    boxShadowHeader: '0 6px 25px rgba(0, 0, 0, 0.5)',
    background: "linear-gradient(to bottom,rgba(0,0,0,0) 0,rgba(0,0,0,0.5) 50%,rgba(0,0,0,0.7) 100%)",
    red: 'red',
    backgroundLight: '#2c54a924',
    backgroundMedium: '#2a3d5f7d',
    backgroundMix: '#a5b6b533',
}

export const lightColor = {
    black: '#fff',
    black1: '#f4f4f4f2',
    white: '#121317',
    whiteLight: '#aaa',
    whiteEEE: '#eee',
    whitePointOne: 'rgba(0, 0, 0, 0.1)',
    white1: '#f4f4f4f2',
    whiteToSecondary: '#272931',
    absoluteAAA: '#aaa',
    primaryLight: '#718EFF',
    primary: '#2616FF',
    primaryDark: '#093234',
    secondaryLight: '#838798',
    secondary: '#f4f4f4f2',
    secondaryDark: '#fff',
    accent: '#FF85FC',
    link: '#d1d155',
    buttonGradient: '#7D73FF',
    search: '#7B8198',
    searchFocus: '#C1C3CB',
    blurEffect: `rgba(255,255,255,.8)`,
    lightBlurEffect: `rgba(18,19,22,.01)`,
    gray: 'rgba(255,255,255,0.6)',
    gray1: 'rgba(0,0,0,0.2)',
    gray2: 'rgba(0,0,0,0.87)',
    gray3: 'rgba(0,0,0,0.05)',
    lightgray: 'rgba(0,0,0,0.03)',
    lightgray1: 'rgba(0,0,0,0.5)',
    lightgray2: 'rgba(0,0,0,0.05)',
    lightgray3: '#F6F7F8',
    lightgray4: 'rgba(0,0,0,0.1)',
    lightBlue1: 'rgba(20,200,230,0.05)',
    lightBlue2: '#F4FDFD',
    blueHeading: '#0a0676',
    gradient: 'linear-gradient(to bottom, #fff, #D6ECFA 30%, #CCFAFF 50%, #D6ECFA 70%, #fff)',
    mainGradient: 'linear-gradient(to right, #AABBFF, #A8A2FF 90%)',
    slantedGradient: 'linear-gradient(45deg, #fff, #D6ECFA 30%, #CCFAFF 50%, #D6ECFA 70%, #fff)',
    boxShadow: "0px 3px 11px 0px #e8eafc, 0 3px 3px -2px #b2b2b21a, 0 1px 8px 0 #9a9a9a1a",
    boxShadowBlack: "0px 3px 11px 0px #999, 0 3px 3px -2px #b2b2b21a, 0 1px 8px 0 #999",
    boxShadowZero: "0px 0px 0px 0px #999, 0 0px 0px 0px #b2b2b21a, 0 0px 1px 0 #999",
    boxShadowFooter: '0 -19px 20px 3px rgba(0, 0, 0, 0.5)',
    boxShadowHeader: '0 6px 25px rgba(0, 0, 0, 0.5)',
    background: "linear-gradient(to bottom,rgba(0,0,0,0) 0,rgba(0,0,0,0.5) 50%,rgba(0,0,0,0.7) 100%)",
    red: 'red',
    backgroundLight: '#2c54a924',
    backgroundMedium: '#2a3d5f7d',
    backgroundMix: '#a5b6b533',
}